import http from '../utils/http';
import {
    defaultState as baseState,
    mutations as baseMutations,
    actions as baseActions
} from './searchBase';

export const defaultState = {
    entityName: 'spaces',
    baseUrl: 'api/spaces/',
    tableName: 'spacesTable',
    ...baseState,
    // all spaces cached
    allSpaces: [],
    allSpacesPending: false,
    spaceStatusSummary: {},
    helpUrl: '/user-guide/guide/spaces.html'
};

export const getters = {
    getSpaceByServiceAccount(state) {
        // will search for space by serviceAccountId
        return serviceAccountId => {
            if (serviceAccountId) {
                return state.allSpaces.filter(item => {
                    return (
                        item.serviceAccount &&
                        item.serviceAccount.id === serviceAccountId
                    );
                });
            }
            return null;
        };
    }
};

export const mutations = {
    ...baseMutations,
    setAllSpaces(state, value) {
        state.allSpaces = Array.isArray(value) ? value : [];
    },
    setAllSpacesPending(state, value) {
        if (typeof value === 'boolean') {
            state.allSpacesPending = value;
        } else {
            state.allSpacesPending = false;
        }
    },
    setSpaceStatusSummary(state, value) {
        if (value) {
            state.spaceStatusSummary = value;
        } else {
            state.spaceStatusSummary = {};
        }
    }
};

export const actions = {
    ...baseActions,
    fetchSpaces({ commit, dispatch, state }, { searchParams, filterParams }) {
        console.log('calling fetchSpaces', searchParams, filterParams);
        const notifyConfig = {
            notifyRequestPending: true
        };
        return dispatch('fetchItems', {
            searchParams,
            filterParams,
            notifyConfig,
            saveParams: true
        }).then(res => {
            const { content, ...page } = res.data;
            commit('setItems', content);
            commit('setResponseQuery', { ...page });
            commit('setRequestQuery', {
                ...state.requestQuery,
                size: page.size,
                number: page.number
            });
        });
    },
    fetchAllSpaces({ commit, dispatch, state }, { notifyConfig }) {
        console.log('calling fetchAllSpaces', state.entityName);
        commit('setAllSpacesPending', true);
        const searchParams = { size: 9999 };
        return dispatch('fetchItems', {
            searchParams,
            notifyConfig
        })
            .then(res => {
                commit('setAllSpaces', res.data.content);
            })
            .finally(() => {
                commit('setAllSpacesPending', false);
            });
    },
    postBulkActions({ dispatch, state }, { action, criteria, params }) {
        console.log('calling postBulkActions', action, criteria, params);
        const successMessage =
            'Bulk action was sent succefully. For job status, please click on the job status icon below.';
        const bulkActions = [
            'reset',
            'checkin',
            'checkout',
            'assignChannelLineup',
            'deleteByCriteria',
            'addTagsByCriteria',
            'removeTagsByCriteria'
        ];
        if (bulkActions.includes(action)) {
            let data = {
                action: action,
                criteria: criteria,
                params: params || {}
            };
            let actionUrl = 'actionByCriteria';
            if (action === 'deleteByCriteria') {
                actionUrl = action;
                data = { criteria };
            } else if (
                action === 'addTagsByCriteria' ||
                action === 'removeTagsByCriteria'
            ) {
                actionUrl = action;
                data = { criteria, tagIds: params };
            }
            return http
                .post(`${state.baseUrl}${actionUrl}`, data, {
                    notifyRequestPending: true,
                    successMessage
                })
                .then(() => {
                    dispatch('showJobsDialog', null, { root: true });
                })
                .finally(() => {
                    // need to refresh the state data
                    if (action === 'deleteByCriteria') {
                        setTimeout(() => {
                            dispatch('fetchAllSpaces', {});
                        }, 300);
                    }
                });
        }
    },
    fetchSpaceStatusSummary({ commit, dispatch, state }, { notifyConfig }) {
        console.log('calling fetchSpaceStatusSummary');
        const fieldName = 'serviceAccount.devices.healthCheckStatus.raw';
        return http
            .get(
                `${state.baseUrl}search/facets/?fields=${fieldName}`,
                notifyConfig
            )
            .then(res => {
                if (res && res.data && res.data.facets) {
                    let summary = {};
                    const facets = res.data.facets;
                    for (const bucket of facets[fieldName]['buckets']) {
                        summary[bucket.key] = { count: bucket.doc_count };
                    }
                    commit('setSpaceStatusSummary', summary);
                    dispatch('fetchEmptySpaces');
                    return summary;
                }
            });
    },
    fetchEmptySpaces({ commit, dispatch, state }) {
        const searchParams = {
            size: 1
        };
        const filterParams = {
            hasDevices: false
        };
        return dispatch('fetchItems', { searchParams, filterParams }).then(
            res => {
                if (res && res.data && res.data.totalElements) {
                    const summary = {
                        ...state.spaceStatusSummary,
                        EMPTY: { count: res.data.totalElements }
                    };
                    commit('setSpaceStatusSummary', summary);
                }
            }
        );
    }
};

export default {
    namespaced: true,
    state: defaultState,
    getters,
    mutations,
    actions
};
